import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a6e973a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OptInContent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "TitleWrapper" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "OptInHeader" }, "Interested in this university?"),
  /*#__PURE__*/_createElementVNode("p", { class: "OptInDescription" }, " Get personalised study recommendations and helpful updates straight to your inbox. ")
], -1 /* HOISTED */))
const _hoisted_3 = { class: "BenefitsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BenefitTitle = _resolveComponent("BenefitTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit) => {
        return (_openBlock(), _createBlock(_component_BenefitTitle, {
          key: benefit,
          title: benefit
        }, null, 8 /* PROPS */, ["title"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}